import { useMemo } from 'react';
import { useMenuActionsBlocker } from '#baseMenu/hooks';
import { StateCallbacks } from '#advertFavorite/objects';

const useStateCallbacks = () => {
  const menuActionsBlocker = useMenuActionsBlocker();

  return useMemo(() => new StateCallbacks({
    onOpen: () => {
      menuActionsBlocker.blockActions();
    },
    onOpened: () => {
      menuActionsBlocker.unblockActions();
    },
    onHide: () => {
      menuActionsBlocker.blockActions();
    },
    onHidden: () => {
      menuActionsBlocker.unblockActions();
    },
  }), [menuActionsBlocker]);
};

export { useStateCallbacks };
